import { Fragment } from "react";

import { useStaticPageContent } from "../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../data/staticContentDefaults";
import CmsRichText from "./CmsRichText";

function LegalPageContent({ slug }) {
  const pageContent = useStaticPageContent(slug);
  const content = pageContent?.title ? pageContent : staticContentDefaults[slug];
  const sections = content?.sections?.length
    ? content.sections
    : staticContentDefaults[slug].sections;

  return (
    <Fragment>
      <div className="container p-5 cms-rich-text-block">
        <h1 className="legal-page-title">
          <CmsRichText as="span" value={content.title} />
        </h1>

        {sections.map((section, index) => (
          <div key={`${section.heading}-${index}`}>
            <h2 className="legal-section-heading">
              <CmsRichText as="span" value={section.heading} />
            </h2>
            <CmsRichText as="div" className="cms-rich-text-block" value={section.body} />
          </div>
        ))}
      </div>
    </Fragment>
  );
}

export default LegalPageContent;
